import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AllThemeCollectionsContainer from './containers/AllThemeCollectionsContainer';
import StorefrontUsageTrackerProvider from '../context/StorefrontUsageTrackerProvider';
import TemplatesHomeContainer from './containers/TemplatesHomeContainer';
import AssetStorefrontContainer from '../storefront/containers/AssetStorefrontContainer';
export default function TemplatesRoutes() {
  const {
    path
  } = useRouteMatch();
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: path,
      exact: true,
      children: /*#__PURE__*/_jsx(StorefrontUsageTrackerProvider, {
        children: /*#__PURE__*/_jsx(TemplatesHomeContainer, {})
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: `${path}/featured`,
      exact: true,
      children: /*#__PURE__*/_jsx(StorefrontUsageTrackerProvider, {
        children: /*#__PURE__*/_jsx(AllThemeCollectionsContainer, {})
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: `${path}/search`,
      exact: true,
      children: /*#__PURE__*/_jsx(StorefrontUsageTrackerProvider, {
        children: /*#__PURE__*/_jsx(AssetStorefrontContainer, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.templates.resultsHeader.title.default"
          })
        })
      })
    }), /*#__PURE__*/_jsx(Redirect, {
      to: path
    })]
  });
}